/* eslint-disable no-param-reassign */
import * as utils from '../../util';
import { layerProcessors } from './layers';

type TabularData = Record<string, string | number>[];

export type Data = { metadata?: unknown; values: TabularData }[];

// 为Layer类型创建统一的接口
export interface BaseLayerSpec {
  type: string;
  encoding?: Record<string, string | string[]>;
  dataIndex?: number;
  __isEncodingValid?: boolean;
}

// 修改Spec接口
export interface Spec {
  layers: BaseLayerSpec[];
}

function isFieldExisted(field: string, data: Data[number]['values']) {
  return data.some(item => Object.prototype.hasOwnProperty.call(item, field));
}

function warn(layer: BaseLayerSpec, field: string) {
  utils.logger.warn(
    'warning',
    `In encoding where case is ${layer.type}: map "${field}" does not exist in the raw data`
  );
}

function warnIfFieldExisted(layer: BaseLayerSpec, field: string, data: Data[number]['values']) {
  const isExistence = isFieldExisted(field, data);
  if (!isExistence) {
    warn(layer, field);
  }
  return isExistence;
}

export default abstract class SpecProcessor {
  static isEncodingValid(data: Data, spec: Spec): boolean {
    let isValid = true;
    const { layers = [] } = spec;
    layers.forEach(layer => {
      const { encoding = {}, dataIndex = 0 } = layer;
      const rawData = data[dataIndex]?.values || [];
      Object.keys(encoding).forEach(key => {
        const value = utils.data.toArray(encoding[key]);
        value.forEach(field => {
          const isExistence = warnIfFieldExisted(layer, field, rawData);
          if (isValid && !isExistence) {
            isValid = isExistence;
            layer.__isEncodingValid = isExistence;
          }
        });
      });
    });
    return isValid;
  }

  static isDataValid(data: Data, spec: Spec): boolean {
    let isValid = true;
    const { layers = [] } = spec;

    // 处理每个图层
    layers.forEach(layer => {
      // 直接使用layerProcessors对象检查处理器是否存在
      if (layer.type && layerProcessors[layer.type as keyof typeof layerProcessors]) {
        // 调用对应的处理器
        const layerValid = layerProcessors[layer.type as keyof typeof layerProcessors](data, spec);
        isValid = isValid && layerValid;
      }
    });

    return isValid;
  }

  protected _data: Data;

  protected _spec: Spec;

  isValid: boolean;

  constructor(data: Data, spec: Spec) {
    this._data = data;
    this._spec = spec;
    this.isValid = true;
  }

  preprocessing() {
    const { _spec: spec, _data: data } = this;
    return SpecProcessor.isEncodingValid(data, spec);
  }
}
